import { render, staticRenderFns } from "./ParlayGame.vue?vue&type=template&id=5ed55a3d&scoped=true&"
import script from "./ParlayGame.vue?vue&type=script&lang=js&"
export * from "./ParlayGame.vue?vue&type=script&lang=js&"
import style0 from "./ParlayGame.vue?vue&type=style&index=0&id=5ed55a3d&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ed55a3d",
  null
  
)

export default component.exports